import { CategoryItem } from "../../../../../interfaces/Catalogue";
import "./OrderItemContent.scss";
// import FidIconProfile from "../../../images/FID-icon-primary.svg";
import { useEffect, useState } from "react";
import IngredientDetails from "../../../IngedientDetails/IngredientDetails";
import OrderMenuArticles from "./OrderMenuArticles/OrderMenuArticles";

interface OrderItemContentProps {
  categoryItem: CategoryItem;
  mode: number;
  orderItemIndex: number;
  canApplyArticleDiscount?: boolean;
  rewardClaimDisabled?: boolean;
  userLoyalityPoints?: number;
  totalLoyaltyPtsConsomed?: number;
  restaurantId: number;
}

const OrderItemContent = (props: OrderItemContentProps) => {
  const {
    orderItemIndex,
    categoryItem,
    mode,
    canApplyArticleDiscount = false,
    rewardClaimDisabled = false,
    userLoyalityPoints,
    totalLoyaltyPtsConsomed,
    restaurantId,
    
  } = props;

  return (
    <div>
      {categoryItem?.order ? (
        // Is Menu
        <OrderMenuArticles
          menuArticles={categoryItem?.order}
          orderCategoryItemQuantity={(categoryItem.quantity ?? 1)}
          orderType={mode}
          canApplyArticleDiscount={canApplyArticleDiscount}
          categoryItemId={categoryItem.id}
          restaurantId={restaurantId}
          userLoyalityPoints={userLoyalityPoints}
          totalLoyaltyPtsConsomed={totalLoyaltyPtsConsomed}
          orderItemIndex={orderItemIndex}
          rewardClaimDisabled={rewardClaimDisabled}
        />
      ) : (
        // Is Article
        <>
          {categoryItem?.selectedIngredients &&
            categoryItem?.selectedIngredients?.length > 0 && (
              <div className="menu-content">
                <div className="menu-content-wrapper">
                  <div className="menu-list">
                    <div className="menusItemList">
                      <div className="SingleMenuList">
                        <p
                          className="menuSubName"
                          style={{ textTransform: "uppercase" }}
                        ></p>
                        <IngredientDetails
                          selectedIngredients={
                            categoryItem?.selectedIngredients
                          }
                          orderType={mode}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
        </>
      )}
    </div>
  );
};

export default OrderItemContent;
